const SEARCH_DELAY = 300;

export { SEARCH_DELAY };
